import React, {Component} from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Axios from 'axios';
import Swal from 'sweetalert2';
import Configs from '../../../Configs';
import Spinner from '../../../components/UI/Spinner/Spinner';
import moment from 'moment';

const ranges = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
}
class Users extends Component {
    state = {
        loading: false,
        transactions: [],
        last_id: 0,
        pagination_id: "",
        page: 1
    };

    componentDidMount() {
        this.getTransactions();
    }

    getTransactions = () => {
        this.setState({
            loading: true
        })
        const clientid = this.props.match.params.clientId;
        Axios.post(`${Configs.eberUrl}/business`, {
            path: `list/member_transaction`,
            method: "GET",
            data: {
                limit: 20,
                // last_id: this.state.last_id,
                pagination_id: this.state.pagination_id,
                page: this.state.page,
                ...(this.state.fromDate && this.state.toDate ? {
                    from_date: this.state.fromDate.format("YYYY-MM-DD"),
                    to_date: this.state.toDate.format("YYYY-MM-DD")
                }: {})
            }
        }, {
            headers: { 
                'Authorization': `Basic ${clientid}`,
                'Content-Type': 'application/json'
            }
        }).then(res => {
            this.setState({
                loading: false
            })
            const data = {
                ...res.data.data
            }
            const pagination = {
                ...res.data.paging
            }
            let last_id = this.state.last_id;
            if(pagination.last_id !== 0) {
                last_id = pagination.last_id
            }
            this.setState({
                transactions: [...Object.values(data)],
                last_id: last_id,
                pagination_id: pagination.pagination_id
            })
        }).catch(err => {
            this.setState({
                loading: false
            })
            Swal.fire({
                title: "Error when get Transaction"
            });
        });
    }

    prevPage = () => {
        let page = this.state.page;
        if(page === 1) {
            return;
        }
        page = page - 1;
        this.setState({
            page: page
        }, () => {
            this.getTransactions();
        })
    }

    nextPage = () => {
        let page = this.state.page;
        page = page + 1;
        this.setState({
            page: page
        }, () => {
            this.getTransactions();
        })
    }

    changeDateHandler = (picker) => {
        const start = picker.startDate;
        const end = picker.endDate;
        this.setState({
            fromDate: start,
            toDate: end
        }, () => {
            this.getTransactions();
        })
    }

    render() {
        if(this.state.loading) {
            return (
                <React.Fragment>
                    <div className="col-xs-12 col-md-12 col-lg-12">
                        <div className="row text-center">
                            <div className="col-md-12 col-xs-12 col-lg-12">
                                <Spinner></Spinner>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        const transactions = [...this.state.transactions];
        let start = moment();
        let end = moment();
        if(this.state.fromDate && this.state.toDate) {
            start = this.state.fromDate;
            end = this.state.toDate;
        }
        return (
            <React.Fragment>
                 <div className="col-md-9 col-xs-12 col-lg-9 outletDatePicker">
                    <DateRangePicker startDate={start} endDate={end} ranges={ranges} onApply={(e, picker) => {
                            return this.changeDateHandler(picker);
                        }}>
                        {
                            start !== undefined && end !== undefined && start && end ? (
                                <div className="detailDateRage">
                                    <i className="fa fa-calendar"></i>&nbsp;
                                    <span>{start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY')}</span> <i className="fa fa-caret-down"></i>
                                </div>
                            ) : (
                                <div className="detailDateRage">
                                    <i className="fa fa-calendar"></i>&nbsp;
                                    <span>No Choose Date</span> <i className="fa fa-caret-down"></i>
                                </div>
                            )
                        }
                    </DateRangePicker>
                    <br></br>
                    <br></br>
                </div>  
                <div className="col-xs-12 col-md-12 col-lg-12 table-responsive no-padding">
                    <table className="table table-hover reportTable">
                        <tbody>
                            <tr>
                                <th>Channel</th>
                                <th>Type</th>
                                <th>Base</th>
                                <th>User</th>
                                <th>Date</th>
                            </tr>
                            {
                                transactions.map((transaction, key) => {
                                    return (
                                        <tr key={key}>
                                            <td>{transaction.channel}</td>
                                            <td>{transaction.type}</td>
                                            <td>{transaction.base_type}</td>
                                            <td>{transaction.user.display_name}</td>
                                            <td>{moment(transaction.created_at).format("DD-MM-YYYY")}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>    
                </div>
                <div className="col-xs-12 col-md-12 col-lg-12 no-padding">
                    <div class="btn-group">
                        <button type="button" className="btn btn-default" onClick={() => this.prevPage()}>Previous</button>
                        <button type="button" className="btn btn-default" onClick={() => this.nextPage()}>Next</button>
                    </div>
                    <br></br>
                    <br></br>
                    <br></br>
                </div>
            </React.Fragment>
        );
    }
}

export default Users;